import Checkbox, { CheckboxProps } from "@mui/material/Checkbox";
import SvgIcon from "@mui/material/SvgIcon";

const SFCheckbox = (props: CheckboxProps) => {
  return (
    <Checkbox
      {...props}
      checkedIcon={
        <SvgIcon>
          <path
            d="M11.9999 0C8.8173 0 5.76522 1.26429 3.51475 3.51478C1.26428 5.76506 0 8.81738 0 12C0 15.1826 1.26428 18.2349 3.51475 20.4852C5.76522 22.7357 8.8173 24 11.9999 24C15.1825 24 18.2348 22.7357 20.4852 20.4852C22.7357 18.2347 24 15.1826 24 12C24 8.81738 22.7357 5.76506 20.4852 3.51458C18.2348 1.26429 15.1825 0 11.9999 0Z"
            fill="#A19BFD"
          />
          <path
            d="M9.27454 16.6201C9.50218 16.8711 9.80364 17 10.1051 17C10.4066 17 10.708 16.8711 10.9357 16.6201L17.6539 9.21299C18.1154 8.70426 18.1154 7.8835 17.6539 7.38155C17.1925 6.87282 16.4481 6.87282 15.9928 7.38155L10.1113 13.8662L8.00718 11.5532C7.54576 11.0444 6.80133 11.0444 6.34607 11.5532C5.88464 12.0619 5.88464 12.8827 6.34607 13.3846L9.27454 16.6201Z"
            fill="white"
          />
        </SvgIcon>
      }
      icon={
        <SvgIcon>
          <path
            d="M11.9999 0C8.8173 0 5.76522 1.26429 3.51475 3.51478C1.26428 5.76506 0 8.81738 0 12C0 15.1826 1.26428 18.2349 3.51475 20.4852C5.76522 22.7357 8.8173 24 11.9999 24C15.1825 24 18.2348 22.7357 20.4852 20.4852C22.7357 18.2347 24 15.1826 24 12C24 8.81738 22.7357 5.76506 20.4852 3.51458C18.2348 1.26429 15.1825 0 11.9999 0Z"
            fill="#C1C1C1"
          />
          <path
            d="M9.27454 16.6201C9.50218 16.8711 9.80364 17 10.1051 17C10.4066 17 10.708 16.8711 10.9357 16.6201L17.6539 9.21299C18.1154 8.70426 18.1154 7.8835 17.6539 7.38155C17.1925 6.87282 16.4481 6.87282 15.9928 7.38155L10.1113 13.8662L8.00718 11.5532C7.54576 11.0444 6.80133 11.0444 6.34607 11.5532C5.88464 12.0619 5.88464 12.8827 6.34607 13.3846L9.27454 16.6201Z"
            fill="white"
          />
        </SvgIcon>
      }
    />
  );
};

export default SFCheckbox;
